export default {
    countryPill: {
        ariaLabel: 'Country: {country}',
    },
}
